module Dashboard {
    "use strict";

    export function executionCountDirective(): ng.IDirective {
        return {
            restrict: "EA",
            scope: true,
            bindToController: { config: "=" },
            templateUrl: "executionCountsWidgetTemplate.htm",
            controller: "executionCountController as ctrl"
        }
    }
    module.directive("frendsExecutionCountWidget", [executionCountDirective]);

    export class ExecutionCountController {
        public config: IExecutionCountWidget;
        public executionInfo: IExecutionInfoForStatus;

        public static $inject = ["$http", "$interval", "$timeout"];
        constructor(private $http: ng.IHttpService, private $interval: ng.IIntervalService, $timeout: ng.ITimeoutService) {
            this.fetch();
            $timeout(() => $interval(() => this.fetch(), 10 * 60 * 1000), Math.random() * 30 * 1000); // 10 minutes refresh, start delayed by 0-30 sec
        }

        private fetch() {
            let query = {
                environments: this.config.environments,
                rangeInDays: this.config.rangeInDays,
                successfulState: this.config.successWidget
            };
            this.$http.post("Status/ProcessExecutionCounts", query).then((response: any) => {
                if (response.data && response.data.success) {
                    this.executionInfo = response.data.data;
                }
            });
        }

        public updateSettingsCallback(config: IExecutionCountWidget) {
            this.config = config;
            this.fetch();
        }

        public getStatusIcon() {
            return this.config.successWidget ? "fa-check" : "fa-times";
        }

        public getStatusClass() {
            return this.config.successWidget ? "pass" : "fail";
        }

        public getPercentChangeIcon() {
            if (this.executionInfo && this.executionInfo.percentChange !== null) {
                return this.executionInfo.percentChange > 0 ? "fa-arrow-up" : "fa-arrow-down"
            } else {
                return "";
            }
        }

        public getDynamicFontSizeClass() {
            let count = (this.executionInfo) ? this.executionInfo.count.toString().length : 0;
            if (count <= 5) return "font-size-80";
            else if (count === 6) return "font-size-70";
            else if (count === 7) return "font-size-60";
            else if (count === 8) return "font-size-50";
            else return "font-size-20";
        }
    }
    module.controller("executionCountController", ExecutionCountController);
}